import React from 'react';

const UploadDocuments = () => {
  return <div>Upload Documents</div>;
};

export default UploadDocuments;
